(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/common/http'), require('@angular/core'), require('@uirouter/angular'), require('iso-639-1')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/common/http', '@angular/core', '@uirouter/angular', 'iso-639-1'], factory) :
	(factory((global['ngx-ivengi-locale'] = {}),global.http,global.core,global.angular,global.ISO6391));
}(this, (function (exports,http,core,angular,ISO6391) { 'use strict';

ISO6391 = ISO6391 && ISO6391.hasOwnProperty('default') ? ISO6391['default'] : ISO6391;

var LocaleService = /** @class */ (function () {
    function LocaleService(router) {
        this.router = router;
        LocaleService.getCurrentLanguageISO();
    }
    LocaleService.getLocalStorageKey = function () {
        return LocaleService.localStorageKey;
    };
    LocaleService.setLocalStorageKey = function (key) {
        if (typeof key === 'string') {
            LocaleService.localStorageKey = key;
        }
        return LocaleService;
    };
    LocaleService.getDefaultLanguageISO = function () {
        return LocaleService.defaultLanguageISO;
    };
    LocaleService.setTranslations = function (translations) {
        LocaleService.translations = translations;
    };
    LocaleService.setDefaultLanguageISO = function (languageISO) {
        if (typeof languageISO === 'string') {
            LocaleService.defaultLanguageISO = languageISO;
        }
        return LocaleService;
    };
    LocaleService.getCurrentLanguageISO = function () {
        if (!LocaleService.currentLanguageISO && localStorage) {
            var languageISO = localStorage.getItem(LocaleService.localStorageKey);
            if (LocaleService.availableLanguageISO.indexOf(languageISO) !== -1) {
                LocaleService.currentLanguageISO = languageISO;
            }
            else {
                LocaleService.currentLanguageISO = LocaleService.defaultLanguageISO;
            }
        }
        this.saveToStorage(LocaleService.currentLanguageISO);
        return LocaleService.currentLanguageISO;
    };
    LocaleService.saveToStorage = function (languageISO) {
        if (localStorage && (!localStorage.getItem(LocaleService.localStorageKey) || localStorage.getItem(LocaleService.localStorageKey) !== languageISO)) {
            localStorage.setItem(LocaleService.localStorageKey, languageISO);
        }
    };
    LocaleService.prototype.getCurrentLanguageISO = function () {
        return LocaleService.getCurrentLanguageISO();
    };
    LocaleService.setCurrentLanguageISO = function (languageISO) {
        if (typeof languageISO === 'string') {
            if (LocaleService.availableLanguageISO.indexOf(languageISO) !== -1) {
                LocaleService.currentLanguageISO = languageISO;
            }
        }
        return LocaleService;
    };
    LocaleService.prototype.setCurrentLanguageISO = function (languageISO) {
        if (LocaleService.availableLanguageISO.indexOf(languageISO) === -1) {
            return this;
        }
        LocaleService.setCurrentLanguageISO(languageISO);
        var stateNameParts = this.router.stateService.$current.name.split('.');
        try {
            // const newLanguageTranslations = require('../assets/i18n/routes.json')[languageISO];
            var newLanguageTranslations = LocaleService.translations[languageISO];
            var newLanguageUrl = '';
            for (var i = 0; i < stateNameParts.length; i++) {
                var searchKey = stateNameParts.slice(0, (i + 1)).join('.');
                for (var j = 0; newLanguageTranslations; j++) {
                    if (newLanguageTranslations[j].state === searchKey) {
                        newLanguageUrl += newLanguageTranslations[j].url;
                        break;
                    }
                }
            }
            newLanguageUrl = newLanguageUrl.replace(/(?::(\w+))/g, '{$1}');
            var matches = newLanguageUrl.match(/{(\w+)}/g);
            if (matches !== null && matches instanceof Array) {
                for (var i = 0; i < matches.length; i++) {
                    var regex = new RegExp("(" + matches[i] + ")", 'g');
                    newLanguageUrl = newLanguageUrl.replace(regex, this.router.stateService.params[matches[i].replace(/[{|}]/g, '')]);
                }
            }
            LocaleService.saveToStorage(LocaleService.currentLanguageISO);
            window.location.pathname = newLanguageUrl;
        }
        catch (e) { }
        return this;
    };
    LocaleService.setAvailableLanguageISO = function (languageISO) {
        if (languageISO instanceof Array) {
            LocaleService.availableLanguageISO = languageISO.filter(function (iso) {
                return (typeof iso === 'string');
            });
        }
        return LocaleService;
    };
    LocaleService.getAvailableLanguageISO = function () {
        return LocaleService.availableLanguageISO;
    };
    LocaleService.getLanguages = function () {
        // create lookup table for language to languageISO;
        var langLookUp = LocaleService.availableLanguageISO.reduce(function (entries, languageISO) {
            var match = /^([a-z]*)-/i.exec(languageISO);
            entries[(match != null) ? match[1] : languageISO] = languageISO;
            return entries;
        }, {});
        // lookup language and construct and object with languageISO to value mapping.
        return ISO6391.getLanguages(Object.keys(langLookUp)).reduce(function (entries, translation) {
            entries.push({
                languageISO: langLookUp[translation.code],
                code: translation.code,
                name: translation.name,
                nativeName: translation.nativeName
            });
            return entries;
        }, []);
    };
    /**
     * Returns the language code name from the browser, e.g. "en"
     *
     * @returns string
     */
    /**
       * Returns the language code name from the browser, e.g. "en"
       *
       * @returns string
       */
    LocaleService.getBrowserLang = /**
       * Returns the language code name from the browser, e.g. "en"
       *
       * @returns string
       */
    function () {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return undefined;
        }
        var lang = (typeof (window.navigator.languages) !== 'undefined') ? window.navigator.languages[0] : null;
        lang = lang || window.navigator.language || window.navigator['browserLanguage'] || window.navigator['userLanguage'];
        if (lang.indexOf('-') !== -1) {
            lang = lang.split('-')[0];
        }
        if (lang.indexOf('_') !== -1) {
            lang = lang.split('_')[0];
        }
        return lang;
    };
    
    /**
     * Returns the culture language code name from the browser, e.g. "en-US"
     *
     * @returns string
     */
    /**
       * Returns the culture language code name from the browser, e.g. "en-US"
       *
       * @returns string
       */
    LocaleService.getBrowserCultureLang = /**
       * Returns the culture language code name from the browser, e.g. "en-US"
       *
       * @returns string
       */
    function () {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return undefined;
        }
        var lang = window.navigator.languages ? window.navigator.languages[0] : null;
        lang = lang || window.navigator.language || window.navigator['browserLanguage'] || window.navigator['userLanguage'];
        return lang;
    };
    
    LocaleService.localStorageKey = 'cleanzone.languageiso';
    LocaleService.defaultLanguageISO = undefined;
    LocaleService.currentLanguageISO = undefined;
    LocaleService.availableLanguageISO = [];
    LocaleService.translations = {};
    LocaleService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    LocaleService.ctorParameters = function () { return [
        { type: angular.UIRouter, },
    ]; };
    return LocaleService;
}());

var LocaleRequestInterceptor = /** @class */ (function () {
    function LocaleRequestInterceptor(localeService) {
        this.localeService = localeService;
    }
    LocaleRequestInterceptor.prototype.intercept = function (req, next) {
        var headers = req.headers || new http.HttpHeaders();
        headers = headers.set('X-Client-Locale', this.localeService.getCurrentLanguageISO());
        req = req.clone({ headers: headers });
        return next.handle(req);
    };
    LocaleRequestInterceptor.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    LocaleRequestInterceptor.ctorParameters = function () { return [
        { type: LocaleService, },
    ]; };
    return LocaleRequestInterceptor;
}());

function dynamicStateConfigFn(uiRouter, injector, module) {
    try {
        var translations = LocaleService.translations[LocaleService.getCurrentLanguageISO()];
        var states = module.states;
        if (translations || translations instanceof Array === false) {
            for (var i = 0; i < states.length; i++) {
                if (states[i].future && !states[i]._complete) {
                    // remove the lazy loaded module identifier
                    var stateName = states[i].name.replace(/\.\*\*$/g, '');
                    var foundTranslation = false;
                    for (var j = 0; j < translations.length; j++) {
                        if (translations[j].state === stateName) {
                            states[i].url = translations[j].url;
                            states[i]._translate = true;
                            states[i]._complete = true;
                            foundTranslation = true;
                            break;
                        }
                    }
                    if (foundTranslation === false) {
                        throw new Error("No URL translation configured for route \"" + states[i].name + "\"");
                    }
                }
            }
        }
    }
    catch (e) {
        console.warn(e);
    }
}

var LocaleModule = /** @class */ (function () {
    function LocaleModule() {
    }
    LocaleModule.decorators = [
        { type: core.NgModule, args: [{
                    declarations: [],
                    exports: [],
                    imports: [],
                    providers: [
                        LocaleService,
                        { provide: http.HTTP_INTERCEPTORS, useClass: LocaleRequestInterceptor, multi: true },
                    ]
                },] },
    ];
    return LocaleModule;
}());

exports.LocaleModule = LocaleModule;
exports.dynamicStateConfigFn = dynamicStateConfigFn;
exports.LocaleService = LocaleService;
exports.LocaleRequestInterceptor = LocaleRequestInterceptor;

Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/node_modules/@ngx-ivengi/locale/ngx-ivengi-locale.umd.js
// module id = ../../../../@ngx-ivengi/locale/ngx-ivengi-locale.umd.js
// module chunks = vendor